import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Data } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { SortDirection } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { EncryptdecryptService } from './services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class ApiservicesService {
  auth: any = "hasilauth";
  kunci: any;
  authorization: any;
  APIDomain: string;
  SSOApiBase: string;
  TaxPayerApiDomain: string;
  taefstream: string;

  constructor(
    private httpClient: HttpClient,
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {
    this.APIDomain = this.config.APIDomain;
    this.SSOApiBase = this.config.SSOApiBase;
    this.TaxPayerApiDomain = this.config.TaxPayerApiDomain;
    this.taefstream = this.config.taefstream;
  }

  //GENERAL
  CreateGuid() {
    return Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  }
  GenerateHeader() {
    var APPId = 'eCP39';
    var APIKey = 'WLUEWeL3so2hdHhHM5ZYnvzsOUBzSGH4+T3EgrQ91KI=';
    var timeStamp = Math.round(+new Date() / 1000);
    var nonce = this.CreateGuid();
    var key = CryptoJS.enc.Base64.parse(APIKey);
    var signatureRawData = APPId + APIKey + nonce + timeStamp;
    var prehash = CryptoJS.enc.Utf8.parse(signatureRawData);
    var hash = CryptoJS.HmacSHA256(prehash, key);
    var signature = hash.toString(CryptoJS.enc.Base64);
    var HeaderAuth = APPId + ":" + signature + ":" + nonce + ":" + timeStamp;
    return HeaderAuth;
  }
  //SSO
  async RequestToken(): Promise<any> {
    return new Promise((resolve, reject) => {
      const makeRequest = () => {
        let url = `${this.SSOApiBase}/user/requesttoken`;
        this.httpClient.get<Data>(url, { withCredentials: true, observe: 'response' })
          .subscribe({
            next: (data) => {
              resolve(data),
                sessionStorage.setItem('JWTToken', this.encryptDecryptService.encrypt(data.headers.get('Taefauth') || ''))
            },
            error: (err) => reject(err),
          });
      };

      // Wait for config to be loaded
      if (!this.SSOApiBase) {
        const waitForConfig = setInterval(() => {
          if (this.SSOApiBase) {
            clearInterval(waitForConfig);
            makeRequest();
          }
        }, 50);
      } else {
        makeRequest();
      }
    });
  }

  RequestJWT() {
    let url = `${this.SSOApiBase}/user/AuthTaEF`;
    return this.httpClient.get<Data>(url, { withCredentials: true, observe: 'response' })
  }
  LogoutToken() {
    let url = `${this.SSOApiBase}/user/logout`;
    return this.httpClient.get<Data>(url, { withCredentials: true })
  }  

  //TAeF
  /*
  async GetHubunganEjenStaff(FirmID: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.kunci = this.GenerateHeader();
      this.authorization = this.auth + ' ' + this.kunci;
      let url = `https://ezlatihan.hasil.gov.my/TaxPayerApi/api/taef/GetHubunganEjenStaff?FirmaID=${FirmID}`

      let headers = new HttpHeaders(
        {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
          "Authorization": this.authorization
        }
      );

      this.httpClient.get<Data>(url, { headers: headers })
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
*/

  //TAeF
  async GetPaparanAsing(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.taefstream + `/api/Pengumuman/GetPaparan`;

      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }

  GetPaparanAttachmentAsingUrl(contentId: number): string {
    return `${this.taefstream}/api/Pengumuman/GetPaparanAttachment/${encodeURIComponent(contentId)}`;
  }

  async GetHubunganEjenStaff(FirmID: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.kunci = this.GenerateHeader();
      this.authorization = this.auth + ' ' + this.kunci;
      let url = this.TaxPayerApiDomain + `/api/TAeF/GetHubunganEjenStaff?FirmaID=${FirmID}`

      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  
  //SPeFAPI
  //eBorang
  async GetAcknowledment(FirmID:any, FormType: any, YearAssessment: any, TaxRefNum: any, Amendment:any, IDLogin: any): Promise<any> {
    return new Promise((resolve, reject) => {
      //this.kunci = this.GenerateHeader();
      //this.authorization = this.auth + ' ' + this.kunci;
      let url = this.APIDomain + `/api/TAeF/GetSemakan?FirmID=${FirmID}&JenisBorang=${FormType}&Tahun=${YearAssessment}&NoRujukan=${TaxRefNum}&pindaan=${Amendment}&IDLogin=${IDLogin}`;


      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }

  //TAeFAPI
  //TAeF
  async GetEncryptDecrypt(Type: any, TextString: any): Promise<any> { //TYPE 101 = encrypt, 102 = decrypt, 201 = 201, 202 = 202
    return new Promise((resolve, reject) => {
      //this.kunci = this.GenerateHeader();
     // this.authorization = this.auth + ' ' + this.kunci;
      let url = this.APIDomain + `/api/TAeF/GetEnOrDe?Type=${Type}&Input=${TextString}`;
    /*
      let headers = new HttpHeaders(
        {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
          "Content-Type": "text/json;",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Accept, Authorization",
          "Authorization": this.authorization
        }
      );
      */
      this.httpClient.get<Data>(url, { responseType: "text" as "json" })
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmUserByICNO(IDNo: any, FirmID: any, Login: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmUserByICNO?NoPengenalan=${IDNo}&FirmID=${FirmID}&Login=${Login}`;
      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetAllStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetAllStaff`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async UpdateStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.kunci = this.GenerateHeader();
      this.authorization = this.auth + ' ' + this.kunci;
      let url = this.APIDomain + `/api/TAeF/UpdateStaff`
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async DeleteStaff(StaffID: any, TaxAgentID:any, FirmID: any, Role:any,AdminID:any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = TaxAgentID === "" || TaxAgentID === null ? this.APIDomain + `/api/TAeF/DeleteStaff?StaffID=${StaffID}&FirmID=${FirmID}&Role=${Role}&AdminID=${AdminID}` : this.APIDomain + `/api/TAeF/DeleteStaff?StaffID=${StaffID}&TaxAgentID=${TaxAgentID}&FirmID=${FirmID}&Role=${Role}&AdminID=${AdminID}`;
      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async AgihToEjen(FirmID: any, OldEjenID: any, NewEjenID: any, ActionStaffID:any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/AgihToEjen?OldEjenID=${OldEjenID}&NewEjenID=${NewEjenID}&FirmID=${FirmID}&ActionStaffID=${ActionStaffID}`;

      this.httpClient.get<Data>(url)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmList(IDNo: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmList`;
      const body = '"' + IDNo + '"';

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async RegisterForm(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/RegisterForm`
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async ResetForm(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/ResetForm`
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmDetailUsingFirmID(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmDetailUsingFirmID`;
      const body = '"' + Params + '"';

      this.httpClient.post<Data>(url, body, { observe: 'response' })
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async RegisterStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/RegisterStaff`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetListeBorang(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetListeBorang`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetLogAudit(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetLogAudit`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmRelationship(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmRelationship`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetNoRelationshipStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetNoRelationshipStaff`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetNoRelationshipAgentStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetNoRelationshipAgentStaff`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async InsertStaffAgentRelationShip(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/InsertStaffAgentRelationShip`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async InsertStaffRelationShip(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/InsertStaffRelationShip`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmStaff(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmStaff`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetLantikanByStatus(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetLantikanByStatus`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async ProcessLantikan(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/ProcessLantikan`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetLantikanByID(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetLantikanByID`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetTicket(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetTicket`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetDetailTaxPayer(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetDetailTaxPayer`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetFirmDetailByID(FIrmID: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetFirmDetailByID`;
      const body = FIrmID;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetStatusBorang(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetStatusBorang`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetAgentDetailByIDNo(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetAgentDetailByIDNo`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetDistributeList(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetDistributeList`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async DistributeForm(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/DistributeForm`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetListeDTS(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetListeDTS`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async SubmitDTS(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/SubmitDTS`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetTotalAppointed(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetTotalAppointed`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async FormLogin(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/FormLogin`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async GetIntegrationAccess(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/GetIntegrationAccess`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async CreateCP8D(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/CP8D/CreateCP8D`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async SharedIntegrationDetail(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/SharedIntegrationDetail`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async SharedIntegrationLogin(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/SharedIntegrationLogin`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async FrequentFormDetail(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/FrequentFormDetail`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  } //for CKM and CP22
  async FrequentFormlogin(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/FrequentFormlogin`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  } //for CKM and CP22
  async MitrsFormDetail(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/MitrsFormDetail`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async MitrsFormlogin(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/MitrsFormlogin`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  async MitrsFormAcknowledgment(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/MitrsFormAcknowledgment`;
      const body = Params;

      this.httpClient.post<Data>(url, body)
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }
  //Reference if need to add header. current api declared on interceptor
  async TEST(Params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.APIDomain + `/api/TAeF/GetLantikanByID`;
      const body = Params;
      let headers = new HttpHeaders(
        {
          "Access-Control-Allow-Methods": "GET,POST",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "text/json;",
          //"Authorization": "Bearer " + this.JWTToken
        }
      );

      this.httpClient.post<Data>(url, body, { headers: headers })
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
    });
  }

  
}
